import {createBox, createRegularPolygon} from 'ol/interaction/Draw';
import {fromLonLat} from 'ol/proj';
import {never} from 'ol/events/condition';
import {fromCircle as polygonFromCircle} from 'ol/geom/Polygon';

import {MAP_TOOLS} from '@explorer/constants';
import {
  createDrawingStyle,
  getDefaultDrawFunction,
} from '@explorer/util/map-edit-styles';
import {getMaxCircle, getMaxSquare} from '@explorer/util/geom';

const styles = createDrawingStyle(true);

export const DRAW_INTERACTIONS = {
  [MAP_TOOLS.DRAW_LOCKED_CIRCLE]: {
    type: 'Point',
    stopClick: true,
    style: function (feature) {
      const geometry = getMaxCircle(
        fromLonLat(feature.getGeometry().getCoordinates())
      );
      geometry.transform('EPSG:3857', 'EPSG:4326');
      const lineStyle = styles.LineString;
      lineStyle.forEach(ls => ls.setGeometry(geometry));
      const polygonStyle = styles.Polygon;
      polygonStyle.forEach(style => style.setGeometry(geometry));

      return polygonStyle.concat(lineStyle);
    },
    geometryFunction: function (coords) {
      const geom = polygonFromCircle(getMaxCircle(fromLonLat(coords)));
      geom.transform('EPSG:3857', 'EPSG:4326');
      return geom;
    },
    freehandCondition: never,
  },
  [MAP_TOOLS.DRAW_LOCKED_RECT]: {
    type: 'Point',
    stopClick: true,
    style: function (feature) {
      // geomteries are stored and manipulated as EPSG:4326,
      //  but there is some need to use the WebMerc box here.
      const center = fromLonLat(feature.getGeometry().getCoordinates());
      const lineStyle = styles.LineString;
      const geometry = getMaxSquare(center);
      geometry.transform('EPSG:3857', 'EPSG:4326');
      lineStyle.forEach(ls => ls.setGeometry(geometry));
      const polygonStyle = styles.Polygon;
      polygonStyle.forEach(style => style.setGeometry(geometry));

      return polygonStyle.concat(lineStyle);
    },
    geometryFunction(coords) {
      const geom = getMaxSquare(fromLonLat(coords));
      geom.transform('EPSG:3857', 'EPSG:4326');
      return geom;
    },
    freehandCondition: never,
  },
  [MAP_TOOLS.DRAW_POLYGON]: {
    type: 'Polygon',
    style: getDefaultDrawFunction(),
    // drawTool.layer === MAP_DRAW_LAYERS.MEASURE
    stopClick: true,
    freehandCondition: never,
  },
  [MAP_TOOLS.DRAW_CIRCLE]: {
    type: 'Circle',
    stopClick: true,
    style: getDefaultDrawFunction(),
    freehandCondition: never,
    geometryFunction: createRegularPolygon(128),
  },
  [MAP_TOOLS.DRAW_RECT]: {
    type: 'Circle',
    stopClick: true,
    style: getDefaultDrawFunction(),
    geometryFunction: createBox(),
    freehandCondition: never,
  },
  [MAP_TOOLS.DRAW_LINE]: {
    type: 'LineString',
    stopClick: true,
    style: getDefaultDrawFunction(true),
    freehandCondition: never,
  },
};
